<h3>{{ 'orders.collateralClassifications' | transloco }}</h3>

<form [formGroup]="ontarioCollateral">
  <!-- Checkbox list for various item categories -->
  <div class="flex-container flex-item padding-top" name="collateral-classifications">
    @if (uiConfiguration.showConsumerGoods) {
      <mat-checkbox class="flex-item" data-testid="consumer-goods-checkbox"
        [formControlName]="'consumerGoods'">
        {{ 'common.labels.consumerGoods' | transloco }}
      </mat-checkbox>
    }
    @if (uiConfiguration.showInventory) {
      <mat-checkbox class="flex-item" data-testid="inventory-checkbox"
        [formControlName]="'inventory'">{{ 'common.labels.inventory' | transloco }}
      </mat-checkbox>
    }
    @if (uiConfiguration.showEquipment) {
      <mat-checkbox class="flex-item" data-testid="equipment-checkbox"
        [formControlName]="'equipment'">{{ 'common.labels.equipment' | transloco }}
      </mat-checkbox>
    }
  </div>

  <div class="flex-container flex-item padding-top">
    <div class="validated-form-field-container flex-container">
      @if (uiConfiguration.showAccounts) {
        <mat-checkbox class="flex-item" data-testid="accounts-checkbox"
        [formControlName]="'accounts'">{{ 'common.labels.accounts' | transloco }}</mat-checkbox>
      }
      @if (uiConfiguration.showOther) {
        <mat-checkbox class="flex-item" data-testid="other-checkbox"
        [formControlName]="'other'">{{ 'common.labels.other' | transloco }}</mat-checkbox>
      }
      @if (uiConfiguration.showMVIncluded) {
        <mat-checkbox class="flex-item" data-testid="mv-included-checkbox"
          [formControlName]="'mvIncluded'">
        {{ 'orders.vehicleIncluded' | transloco }}</mat-checkbox>
      }
      <lib-error-bubble [control]="ontarioCollateral" [message]="collateralClassificationsError$"></lib-error-bubble>
    </div>
  </div>
</form>